module.exports = __webpack_public_path__ + "static/media/realtors-icon-12.7fb4d689.svg";